import axios, { AxiosInstance } from 'axios';
import config from './config';
import envConfig from '../../config/env-config';
let urlPrefix = envConfig.urlPrefix;

let configEnv = process.env['CONFIG_ENV'] || 'local';
if (configEnv === 'local' && location.pathname === '/ces') {
    urlPrefix = 'https://brain.meituan.com';
}

if (process.env.NODE_ENV !== 'production') {
    // console.log('开发环境会设置鉴权');
    // config.headers['token'] = 'cbe2fd29b2d45c014e3e2909e522cdd3';
}
// export const service = axios.create(config);
export const service = (axios.create as any)(config);

service.interceptors.response.use(function (response) {
    let {data} = response;
    // 已经提示过的错误就不要再让业务层提示了
    if (data.code === 412 && data.message === 'Too many visits from current user') {
        return Promise.reject({type: 'ignore'});
    }
    if (data.message === 'invalid permission' || data.message === 'no sufficient privilege') {
        return Promise.reject({type: 'ignore'});
    }
    return response;
}, function (error) {
    debugger
    return Promise.reject(error);
});

// service.defaults.withCredentials = true;

export interface AnyFunc extends AxiosInstance {
    (data: any): Promise<any>;
}

export interface RequestType {
    path: string;
    method: string;
    params: any;
    responseType?: string;
    cancelToken?: any;
}

const request = async (data: RequestType): Promise<any> => {
    // await $sleep(5000); // 模拟超级慢的网速
    const { path, method, params, responseType } = data;
    let payload: any = { url: urlPrefix + path, method };
    if (path.indexOf('financeRelationMap') !== -1) {
        payload = { url: path, method };
    }
    if (path.indexOf('searchFinance') !== -1) {
        payload = { url: path, method };
    }
    payload = method === 'post' ? { ...payload, data: params } : { ...payload, params };
    // TODO 其他所有属性的覆盖
    if (responseType) {
        payload.responseType = responseType;
    }
    let response = (service as AnyFunc)(payload);
    return response.then((val) => {
        return val.data;
    });
};

export default request;
